
// Format detection utilities
let avifSupport: boolean | null = null;
let webpSupport: boolean | null = null;

// Detect if AVIF format is supported
export const isAvifSupported = (): boolean => {
  if (typeof document === 'undefined') return false;
  const canvas = document.createElement('canvas');
  return canvas.toDataURL('image/avif').indexOf('data:image/avif') === 0;
};

// Detect if WebP format is supported
export const isWebpSupported = (): boolean => {
  if (typeof document === 'undefined') return false;
  const canvas = document.createElement('canvas');
  return canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;
};

/**
 * Get the best supported image format
 */
export const getBestSupportedFormat = (requestedFormat: 'webp' | 'avif' | 'png' | 'jpeg' = 'webp'): string => {
  // Initialize format support check if needed
  if (avifSupport === null && typeof window !== 'undefined') {
    avifSupport = isAvifSupported();
  }
  
  if (webpSupport === null && typeof window !== 'undefined') {
    webpSupport = isWebpSupported();
  }
  
  // Select most optimal format based on support and request
  if (requestedFormat === 'avif' && avifSupport) {
    return 'avif';
  } else if ((requestedFormat === 'webp' || requestedFormat === 'avif') && webpSupport) {
    return 'webp';
  } else if (requestedFormat === 'png' || requestedFormat === 'jpeg') {
    return requestedFormat;
  }
  
  return 'jpeg'; // Fallback format
};
